import { GradingScheme } from 'app/library/grading-scheme/models/grading-scheme.model';
import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { ICreateGradingSchemeModel } from '../interfaces/create-grading-scheme.interface.model';

export class SetGradingScheme {
    static readonly type = '[GradingScheme] SetGradingScheme';

    constructor(public payload: GradingScheme) {}
}

export class UnsetGradingScheme {
    static readonly type = '[GradingScheme] UnsetGradingScheme';
}

export class FetchGradingScheme {
    static readonly type = '[GradingScheme] FetchGradingScheme';

    constructor(public payload: string) {}
}

export class FetchGradingSchemeSuccess {
    static readonly type = '[GradingScheme] FetchGradingSchemeSuccess';

    constructor(public payload: GradingScheme) {}
}

export class FetchGradingSchemeFailure {
    static readonly type = '[GradingScheme] FetchGradingSchemeFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class AddGradingSchemes {
    static readonly type = '[GradingScheme] AddGradingSchemes';

    constructor(public payload: GradingScheme[]) {}
}

export class CreateGradingScheme {
    static readonly type = '[GradingScheme] CreateGradingScheme';

    constructor(public payload: ICreateGradingSchemeModel) {}
}

export class CreateGradingSchemeSuccess {
    static readonly type = '[GradingScheme] CreateGradingSchemeSuccess';

    constructor(public payload: GradingScheme) {}
}

export class CreateGradingSchemeFailure {
    static readonly type = '[GradingScheme] CreateGradingSchemeFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateGradingScheme {
    static readonly type = '[GradingScheme] UpdateGradingScheme';

    constructor(public payload: GradingScheme) {}
}

export class UpdateGradingSchemeSuccess {
    static readonly type = '[GradingScheme] UpdateGradingSchemeSuccess';

    constructor(public payload: GradingScheme) {}
}

export class UpdateGradingSchemeFailure {
    static readonly type = '[GradingScheme] UpdateGradingSchemeFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class DeleteGradingScheme {
    static readonly type = '[GradingScheme] DeleteGradingScheme';

    constructor(public payload: string) {}
}

export class DeleteGradingSchemeSuccess {
    static readonly type = '[GradingScheme] DeleteGradingSchemeSuccess';

    constructor(public payload: string) {}
}

export class DeleteGradingSchemeFailure {
    static readonly type = '[GradingScheme] DeleteGradingSchemeFailure';

    constructor(public payload: string) {}
}

export class SetGradingSchemes {
    static readonly type = '[GradingScheme] SetGradingSchemes';

    constructor(public payload: GradingScheme[]) {}
}

export class FetchGradingSchemes {
    static readonly type = '[GradingScheme] FetchGradingSchemes';
}

export class FetchGradingSchemesSuccess {
    static readonly type = '[GradingScheme] FetchGradingSchemesSuccess';
}

export class FetchGradingSchemesFailure {
    static readonly type = '[GradingScheme] FetchGradingSchemesFailure';
}

export class ToggleSelectedGradingScheme {
    static readonly type = '[GradingScheme] ToggleSelectedGradingScheme';

    constructor(public payload: string) {}
}

export class SelectFilteredGradingSchemes {
    static readonly type = '[GradingScheme] SelectFilteredGradingSchemes';
}

export class DeselectSelectedGradingSchemes {
    static readonly type = '[GradingScheme] DeselectSelectedGradingSchemes';
}

export class SearchGradingSchemes {
    static readonly type = '[GradingScheme] SearchGradingSchemes';

    constructor(public payload: string) {}
}

export class DeleteSelectedGradingSchemes {
    static readonly type = '[GradingScheme] DeleteSelectedGradingSchemes';
}

export class UnsetGradingSchemeSearchTerm {
    static readonly type = '[GradingScheme] UnsetGradingSchemeSearchTerm';
}
